import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { heroImage, included } from '../data/copy';
import { launchPrice, totalValue, valueStack } from '../data/valueStack';
const assurances = ['Secure payment', 'Instant download', '7-day money back guarantee'];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-12 bg-navy-deep py-10 sm:py-12" aria-labelledby="offer-heading" data-id="element-106" data-mp="idrmbl71uixa">
      <div className="mx-auto max-w-5xl px-6" data-id="element-107" data-mp="md0c6eyyxwnk">
        <div className="mx-auto max-w-xl" data-id="element-108" data-mp="re696oznw62w">
          <CountdownTimer data-id="element-109" data-mp="refwg4tbnz4w" />
        </div>

        <div className="mx-auto mt-6 max-w-2xl text-center" data-id="element-110" data-mp="wczis6btvcxs">
          <p className="eyebrow text-lime" data-id="element-111" data-mp="wc817zf2ffqi">💰 The value stack</p>
          <h2 id="offer-heading" className="mt-2.5 font-display text-[1.7rem] font-extrabold leading-[1.1] text-shell sm:text-[2.2rem]" data-id="element-112" data-mp="2t62v8sjggybx">
            $308 of coaching system. $27 today.
          </h2>
        </div>

        <div className="mt-5 grid gap-5 rounded-4xl bg-shell p-4 shadow-lift sm:p-6 lg:grid-cols-2 lg:gap-7" data-id="element-113" data-mp="12plckvyk3hav">
          {/* Left: what you actually get. */}
          <div className="flex flex-col" data-id="element-114" data-mp="syqmthm3pzko">
            <div className="rounded-2xl bg-sand p-3" data-id="element-115" data-mp="svm99tmqxrhc">
              <img src={heroImage} alt="Everything included: six volumes, seven strategic bonuses and printable coaching resources." className="mx-auto w-full max-w-[12rem] lg:max-w-[14rem]" width={1240} height={1240} sizes="224px" loading="lazy" decoding="async" data-id="element-116" data-mp="ox52xcb5gl0z" />
            </div>

            <p className="eyebrow mt-4 text-navy" data-id="element-117" data-mp="17mbrhfymk6up">Everything included</p>
            <ul className="mt-2.5 space-y-1" data-id="element-118" data-mp="17khmmrixboj">
              {included.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.8rem] leading-snug text-ink/85" data-id="element-119" data-mp="3sckl50tom0x7">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-lime-ink" strokeWidth={2.6} aria-hidden="true" data-id="element-120" data-mp="2noivpivo7ls" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Right: the price and the purchase button. */}
          <div id="price" className="flex scroll-mt-20 flex-col rounded-3xl border border-line bg-ivory p-4 sm:p-5" data-id="element-121" data-mp="3b1x7ynm6yg97">
            <dl data-id="element-122" data-mp="315luhuav7kd6">
              {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 border-b border-line py-1.5 font-sans text-[0.82rem] text-ink/85 first:pt-0" data-id="element-123" data-mp="317579axbbda7">
                  <dt data-id="element-124" data-mp="2x3qssop0v4yv">{line.label}</dt>
                  <dd className="font-display font-bold text-stone line-through" data-id="element-125" data-mp="2x2p4hiizwlz7">
                    {line.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4 pt-2 font-sans text-[0.82rem] font-semibold text-ink" data-id="element-126" data-mp="28j3zlju562sh">
                <dt data-id="element-127" data-mp="2mjodc1l798f4">Total real-world value</dt>
                <dd className="font-display text-[0.95rem] font-extrabold text-stone line-through" data-id="element-128" data-mp="2mgaeh3bqvhcf">
                  {totalValue}
                </dd>
              </div>
            </dl>

            <div className="mt-4 rounded-2xl border border-lime-ink/30 bg-lime-soft px-4 py-4 text-center" data-id="element-129" data-mp="2weq38znaueir">
              <p className="eyebrow text-lime-ink" data-id="element-130" data-mp="2rfvms4ct121t">Launch price today</p>
              <p className="mt-1 font-display text-[2.75rem] font-extrabold leading-none text-ink" data-id="element-131" data-mp="3662txnxd2yn7">
                {launchPrice}
              </p>
              <p className="mt-1.5 font-sans text-xs uppercase tracking-[0.12em] text-stone" data-id="element-132" data-mp="3f711gg70doaj">
                One payment · adjusts to your local currency
              </p>
            </div>

            <CtaButton size="large" className="mt-3.5 w-full" data-id="element-133" data-mp="18j1wa78i7dev">
              Get instant access
            </CtaButton>

            <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-id="element-134" data-mp="1dhbp4b6ra1xb">
              {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-sans text-xs text-stone" data-id="element-135" data-mp="1i9n0qbauzc5p">
                  <CheckIcon className="h-3 w-3 text-lime-ink" strokeWidth={2.6} aria-hidden="true" data-id="element-136" data-mp="pkpgw3r017au" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}